<template>
  <v-container fluid>
    <TopHeader>
      <template v-slot:title>
        <span class="text-h5">
          Manage users
        </span>
      </template>
    </TopHeader>
    <v-row>
      <v-col>
        <manage-users
          fill-height
          searchable
          :height="$vuetify.breakpoint.height - 280"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import TopHeader from "@/components/base/TopHeader.vue"
import UsersCrud from "@/components/hmd/Users/UsersCrud"
export default {
  name: "Utilisateurs",
  components: {
    TopHeader,
    "manage-users": UsersCrud
  }
}
</script>

<style scoped>
#core-view {
  padding-bottom: 0 !important;
}
</style>
